import { AlertItem } from '../types';
import { INITIAL_ALERTS } from '../data/mockState';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
const ALERTS_STORAGE_KEY = 'idfraud_alerts_list';

function getStoredAlerts(): AlertItem[] {
  const raw = localStorage.getItem(ALERTS_STORAGE_KEY);
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      return INITIAL_ALERTS;
    }
  }
  localStorage.setItem(ALERTS_STORAGE_KEY, JSON.stringify(INITIAL_ALERTS));
  return INITIAL_ALERTS;
}

export async function getAlerts(): Promise<AlertItem[]> {
  await delay(300);
  return getStoredAlerts();
}

export async function resolveAlert(alertId: string): Promise<AlertItem[]> {
  await delay(400);
  const current = getStoredAlerts();
  const updated = current.map(item => {
    if (item.id === alertId) {
      return {
        ...item,
        isResolved: true,
        resolvedAt: new Date().toISOString()
      };
    }
    return item;
  });
  localStorage.setItem(ALERTS_STORAGE_KEY, JSON.stringify(updated));
  return updated;
}

export async function createAlert(newAlert: Omit<AlertItem, 'id' | 'date' | 'isResolved'>): Promise<AlertItem> {
  await delay(400);
  const current = getStoredAlerts();
  const item: AlertItem = {
    ...newAlert,
    id: 'alt-' + Math.random().toString(36).substring(2, 7),
    date: new Date().toISOString(),
    isResolved: false
  };
  const updated = [item, ...current];
  localStorage.setItem(ALERTS_STORAGE_KEY, JSON.stringify(updated));
  return item;
}
